import { render, staticRenderFns } from "./questionNew.vue?vue&type=template&id=dde61c2e&scoped=true&"
import script from "./questionNew.vue?vue&type=script&lang=js&"
export * from "./questionNew.vue?vue&type=script&lang=js&"
import style0 from "./questionNew.vue?vue&type=style&index=0&id=dde61c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde61c2e",
  null
  
)

export default component.exports